import numeral from 'numeral';
import { DataDTOTransactionHistory } from 'src/types/api/generated/api';
import { TransactionStatusFilter } from 'src/types/transaction';
import { buildNestedFilters, TableFilter } from 'src/utils/tableQuery';

const cashPaymentType = 'Cash';

export const buildCashTransactionFilters = (
  filters: TableFilter[],
  startISO: string,
  endISO: string
): Record<string, unknown> => ({
  ...buildNestedFilters(filters),
  status: TransactionStatusFilter.Completed,
  creditType: cashPaymentType,
  startedAt: {
    from: startISO,
    to: endISO
  }
});

export const formatCashierName = (
  transaction: DataDTOTransactionHistory
): string => {
  const name = [transaction.cashierFirstName, transaction.cashierLastName]
    .filter(Boolean)
    .join(' ');
  return name || 'N/A';
};

export const formatCurrency = (value?: number | null): string =>
  typeof value === 'number' ? numeral(value).format('$0,0.00') : 'N/A';
